import { render, staticRenderFns } from "./ExpiredAccountsReceivable.vue?vue&type=template&id=95306784&scoped=true"
import script from "./ExpiredAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./ExpiredAccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./ExpiredAccountsReceivable.vue?vue&type=style&index=0&id=95306784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95306784",
  null
  
)

export default component.exports